import { Grid, Typography } from "@mui/material";
import useTheme from "@mui/material/styles/useTheme";
import { iconList } from "react-icomoon";
import background from "../../assets/profile_bg.png";
import { GridMain, Icon } from "../../components";
import { useAuthStore } from "../../stores";
import iconSet from "../../styles/icon-json/selection.json";

export function IconSetPage() {
  const icons = iconList(iconSet);
  const theme = useTheme();
  const setSpinnerLoginVisible = useAuthStore(state => state.setSpinnerLoginVisible);
  setSpinnerLoginVisible(false);
  return (
    <>
      <GridMain>
        <Typography
          fontSize={ "50px" }
          padding={ "40px" }
        >
          Icone :
        </Typography>
        <Grid
          item
          container
          display={ "flex" }
          flexWrap={ "wrap" }
          gap={ "50px" }
          padding={ "40px" }
        >
          {
            icons.map((icon,index) => {
              return(
                <Grid
                  alignItems={ "center" }
                  display={ "flex" }
                  flexDirection={ "column" }
                  gap={ "8px" }
                  key={ index }
                  width={ "calc(17% - 50px)" }
                  justifyContent={ "flex-end" }
                  sx={ {
                    [theme.breakpoints.down("md")]: {
                      width:"calc(25% - 50px)"
                    }
                  } }
                >
                  <Icon icon={ icon } size={ 30 }/>
                  <Typography
                    fontSize={ "1rem" }
                    sx={ {
                      wordBreak:"break-all"
                    } }>
                    { icon }
                  </Typography>
                </Grid>
              );
            })
          }
        </Grid>
        <Grid
          width={ "100%" }
          height={ "700px" }
          sx={ {
            backgroundImage:`${theme.linearGradients.gradientD}, url(${background})`,
            position:"relative",

            "&:before":{
              content:"''",
              position:"absolute"

            }
          } }
        >
        </Grid>
      </GridMain>
    </>
  );
}
